const MuiToggleButtonGroup = {
    defaultProps: {
        size: 'small',
        exclusive: true
    }
};
export { MuiToggleButtonGroup };

//# sourceMappingURL=togglebuttongroup-overrides.js.map